import React from "react";

const links = [
  {
    name: "Home",
    link: "#top"
  },
  {
    name: "Services",
    link: "#services"
  },
  {
    name: "Industries",
    link: "#industries"
  },
  {
    name: "POM",
    link: "#pom"
  },
  {
    name: "Testimonies",
    link: "#testimonies"
  },
  {
    name: "Contact",
    link: "#contact"
  }
]

export default function Navbar() {
  return (
    <nav className="bg-neutral-900 text-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
        <a href="http://smartguytechnologies.com"><img src="/banner 720x150.png" alt="Smartguy Technologies" className="h-10 md:h-12" /></a>
        <ul className="hidden md:flex space-x-6 text-sm font-medium">
          {links.map((link, index) => (
            <li className="hover:text-gray-300 cursor-pointer"><a href={link.link}>{link.name}</a></li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
